import React from 'react';
import PropTypes from 'prop-types';

const ReadOnlyField = ({ label, value }) => (
  <div className="flex flex-col">
    <span
      className="text-[14px] font-semibold leading-[18px] text-black mb-1"
      style={{ fontFamily: 'Poppins, sans-serif' }}
    >
      {label}
    </span>
    <span
      className="text-[14px] font-normal leading-[18px] text-black"
      style={{ fontFamily: 'Poppins, sans-serif' }}
    >
      {value || '—'}
    </span>
  </div>
);

ReadOnlyField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string
};

export default ReadOnlyField;
